import _ from 'lodash';

import Popup from '~makosh/assets/components/popup/popup';

export default class ImgPopup extends Popup {
    constructor(options = {}) {
        super({noInit: true});
        this.init(Object.assign({
            class: 'img-popup group',
            content: _.template('<img src="<%- url %>">')(options),
        }, options));
    }
}



// WEBPACK FOOTER //
// ./legacy/assets/components/img-popup.js